let config = {};

if (window.location.hostname === "localhost") {
    config.apiUrl = '/api';
} else {
    config.apiUrl = 'https://delivery.parksidedev.com/api';
}


export default config;